// extracted by mini-css-extract-plugin
module.exports = {"languageBtn":"LanguageBtn_languageBtn___T1HW","loginLanguageBtn":"LanguageBtn_loginLanguageBtn__2xmAU"};